import axios from "axios";

export const USER_GROUP_URL = "/UserGroup";

/** Belli Bir Kullanıcı Grubu Listesini Elde Eder */
export function getUserGroups(queryParams) {
  return axios.post(`${USER_GROUP_URL}/GetUserGroups`, queryParams);
}

/** Belli Bir Kullanıcı Grubu Listesini Sayfalama Olmadan Elde Eder */
export function getAllUserGroups(queryParams) {
  return axios.post(`${USER_GROUP_URL}/GetAllUserGroups`, queryParams);
}

/** Yeni Bir Kullanıcı Grubu Elde Eder */
export function getNewUserGroup() {
  return axios.get(USER_GROUP_URL);
}

/** Belli Bir Kullanıcı Grubunu Elde Eder */
export function getUserGroup(id) {
  return axios.get(`${USER_GROUP_URL}/${id}`);
}

/** Belli Bir Kullanıcı Grubunu Kaydeder */
export function saveUserGroup(userGroup) {
  return axios.post(USER_GROUP_URL, userGroup);
}

/** Belli Bir Kullanıcı Grubu Listesini Siler */
export function deleteUserGroups(ids) {
  return axios.post(`${USER_GROUP_URL}/Delete`, ids);
}